<template>
  <div class="addMaterialy">
    <el-dialog class="text-center" title="添加材料" :visible.sync="addMaterialyVisible" width="1250px" :show-close="true" append-to-body v-if="addMaterialyVisible">
      <div class="content text-left flex h-100 bg-f3f4f7">
        <div id="moveLeftM" class="h-100 flex-column bg-ff menu" style="width: 200px">
          <div class="left-top">
            <div class="flex-1 font-16-30313a">材料分类</div>
          </div>
          <div class="flex-1 h-0" v-if="menuList && menuList.length">
            <cate-menu :menu-data="menuList" @on-choose="onChooseMenu" :choose-id="chooseDeptId" :not-operate="true"></cate-menu>
          </div>
        </div>
        <move-horizon moveId="moveLeftM"></move-horizon>
        <div class="flex-1 flex-column w-0 ptb-10 pr-20" v-if="currentMenu">
          <div class="flex mb-10">
            <div class="title flex align-center bg-ff flex-1">
              <div class="decoration-line mr-5"></div>
              <div class="font-16-46b8b0 font-bold">材料列表: {{currentMenu.name}}</div>
            </div>
            <div class="flex ml-10">
              <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
                <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
                <el-input type="text" placeholder="材料/品牌/规格型号/编码" v-model="keywords" clearable @keyup.enter.native="searchBtn"></el-input>
              </div>
              <button class="btn-30-bg-46b8b0" @click="searchBtn">搜索</button>
            </div>
          </div>
          <div class="flex-1 flex-column h-0 mb-10">
            <erp-table ref="erpTable" :customs="[{field: 'curBalanceQuantity', visible: orderDefine.type === 11 || orderDefine.type === 14}]" :table-data="tableData" :loading="loading" :column-data="columnData" @on-add="onAdd"></erp-table>
          </div>
          <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ErpTable from '../../../components/ErpTable'
import CateMenu from '../../../components/CateMenu'
import MoveHorizon from '../../../components/MoveHorizon'
import Pagination from '@/components/Pagination'
export default {
  name: 'addMaterialy',
  components: {ErpTable, CateMenu, MoveHorizon, Pagination},
  props: ['orderDefine', 'receiptStatus', 'storehouseId'],
  data () {
    return {
      addMaterialyVisible: false,
      chooseDeptId: 0,
      menuList: [],
      loading: true,
      tableData: [],
      columnData: [{
        field: 'operate',
        title: '操作',
        width: '70',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '添加',
          methodName: 'on-add',
          type: 'btn'
        }]
      }, {
        field: 'curBalanceQuantity',
        title: '可用量',
        width: '100'
      }, {
        field: 'code',
        title: '材料编码',
        minWidth: '120'
      }, {
        field: 'brand',
        title: '品牌',
        minWidth: '120'
      }, {
        field: 'name',
        title: '材料名称',
        minWidth: '150'
      }, {
        field: 'standard',
        title: '规格',
        minWidth: '120'
      }, {
        field: 'model',
        title: '型号',
        minWidth: '100'
      }, {
        field: 'salesUnit',
        title: '单位',
        width: '100'
      }, {
        field: this.orderDefine.costPriceField,
        title: '采购价',
        width: '120'
      }],
      currentMenu: null,
      keywords: null,
      page: 1,
      limit: 25,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 100 // 总条数
    }
  },
  created () {
    this.getData()
  },
  mounted () {
  },
  methods: {
    onChooseMenu (menu) {
      if (menu.id !== this.chooseDeptId) {
        this.chooseDeptId = menu.id
        this.currentMenu = menu
        this.getData()
      }
    },
    getAllMenu () {
      this.menuList = []
      this.axios.post(`materialClassify/findAllClassify`, {
        companyId: this.$store.state.companyId,
        inventoryFlag: this.orderDefine.storehouseFlag
      }).then(res => {
        if (res.data.success) {
          this.menuList = res.data.data
          if (this.menuList.length > 0) {
            this.currentMenu = this.menuList[0]
            this.getData()
          }
        }
      })
    },
    getData () {
      let params = {
        companyId: this.$store.state.companyId,
        inventoryFlag: this.orderDefine.storehouseFlag === -1 ? -2 : this.orderDefine.type === 14 ? 2 : this.orderDefine.storehouseFlag,
        // classifyId: this.currentMenu.id,
        page: this.page,
        limit: this.limit,
        status: 1,
        keywords: this.keywords
      }
      if (this.currentMenu) {
        params.classifyId = this.currentMenu.id
      }
      if (this.orderDefine.type === 11 || this.orderDefine.type === 14) {
        params.storehouseId = this.storehouseId
      }
      this.axios.post(`material/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
          this.loading = false
        }
      })
    },
    searchBtn () {
      this.page = 1
      this.getData()
    },
    onAdd (row) {
      // console.log(row)
      let flag = true
      if (this.orderDefine.storehouseFlag !== -1) {
        for (let i = 0; i < this.$parent.$parent.tableData.length; i++) {
          if (this.$parent.$parent.tableData[i].id === row.id) {
            flag = false
            break
          }
        }
      }
      // console.log(66666666)
      // console.log(this.orderDefine.storehouseFlag)
      // console.log(flag)
      if (flag) {
        let arr = ['totalCost']
        if (this.orderDefine.costPriceAdd !== 1) {
          arr.push(this.orderDefine.costPriceField)
        }
        if (this.orderDefine.customerPriceAdd !== 1) {
          arr.push('customerPrice')
        }
        if (row.isModified === -1) {
          let unEditableArr = ['materialCode', 'materialName', 'materialMode', 'materialUnit']
          arr = arr.concat(unEditableArr)
        }
        let item = {
          ...row,
          name: row.name,
          unEditable: arr.join(','),
          materialId: row.id,
          materialName: row.name,
          materialCode: row.code,
          materialStandard: row.standard,
          materialMode: row.model,
          materialUnit: row.unit || row.salesUnit,
          specialItem: row.specialItem,
          quantity: 1,
          totalCost: row[this.orderDefine.costPriceField],
          totalCustomer: row[this.orderDefine.customerPriceField] === -1 ? 0 : row[this.orderDefine.customerPriceField],
          customerPrice: row[this.orderDefine.customerPriceField] === -1 ? 0 : row[this.orderDefine.customerPriceField],
          costPrice: row[this.orderDefine.costPriceField],
          projectPrice: row.projectPrice,
          remark: row.remark,
          chargebackId: row.chargebackId,
          isModified: row.isModified,
          businessId: row.businessId,
          businessName: row.businessName,
          curBalanceQuantity: row.curBalanceQuantity
        }
        let addFlag = true
        if (this.$parent.$parent.addMaterialList.length > 0) {
          for (let k of this.$parent.$parent.addMaterialList) {
            if (k.materialId === item.materialId && this.orderDefine.storehouseFlag !== -1) {
              addFlag = false
              break
            }
          }
        }
        // console.log(777777777)
        // console.log(addFlag)
        if (addFlag) {
          for (let i of this.$parent.$parent.tableData) {
            if (i.materialId === item.materialId && this.orderDefine.storehouseFlag !== -1) {
              addFlag = false
              for (let j of this.$parent.$parent.deleteMaterialList) {
                if (j.materialId === item.materialId) {
                  addFlag = true
                  break
                }
              }
              break
            }
          }
        }
        // console.log(88888888888)
        // console.log(addFlag)
        if (addFlag) {
          if (this.orderDefine.type === 11 || this.orderDefine.type === 14 || this.orderDefine.type === 15) {
            if (this.orderDefine.type === 15) {
              if (this.receiptStatus === 0) { // 0新增 1详情
                if (this.$parent.$parent.businessId) {
                  this.$parent.$parent.tableData.push(item)
                  if (item.businessId !== null) {
                    this.$parent.$parent.businessId = item.businessId
                    this.$parent.$parent.businessName = item.businessName
                  }
                  this.$message({
                    message: '材料添加成功',
                    type: 'success'
                  })
                } else {
                  if (this.$parent.$parent.tableData.length > 0) {
                    this.$parent.$parent.tableData.push(item)
                    if (item.businessId !== null) {
                      this.$parent.$parent.businessId = item.businessId
                      this.$parent.$parent.businessName = item.businessName
                    }
                    this.$message({
                      message: '材料添加成功',
                      type: 'success'
                    })
                  } else {
                    this.$parent.$parent.tableData.push(item)
                    if (item.businessId !== null) {
                      this.$parent.$parent.businessId = item.businessId
                      this.$parent.$parent.businessName = item.businessName
                    } else {
                      this.$parent.$parent.businessId = null
                      this.$parent.$parent.businessName = ''
                    }
                    this.$message({
                      message: '材料添加成功',
                      type: 'success'
                    })
                  }
                }
              } else {
                if (this.$parent.$parent.businessId === item.businessId) {
                  this.$parent.$parent.$refs.erpTable.insertAt(item, -1)
                  this.$parent.$parent.getAddData()
                  this.$message({
                    message: '材料添加成功',
                    type: 'success'
                  })
                } else {
                  this.$message({
                    message: `您选择的材料不是同一供应商`,
                    type: 'warning'
                  })
                }
              }
            } else {
              if (item.curBalanceQuantity > 0) {
                if (this.receiptStatus === 0) { // 0新增 1详情
                  if (this.$parent.$parent.businessId) {
                    this.$parent.$parent.tableData.push(item)
                    if (item.businessId !== null) {
                      this.$parent.$parent.businessId = item.businessId
                      this.$parent.$parent.businessName = item.businessName
                    }
                    this.$message({
                      message: '材料添加成功',
                      type: 'success'
                    })
                  } else {
                    if (this.$parent.$parent.tableData.length > 0) {
                      this.$parent.$parent.tableData.push(item)
                      if (item.businessId !== null) {
                        this.$parent.$parent.businessId = item.businessId
                        this.$parent.$parent.businessName = item.businessName
                      }
                      this.$message({
                        message: '材料添加成功',
                        type: 'success'
                      })
                    } else {
                      this.$parent.$parent.tableData.push(item)
                      if (item.businessId !== null) {
                        this.$parent.$parent.businessId = item.businessId
                        this.$parent.$parent.businessName = item.businessName
                      } else {
                        this.$parent.$parent.businessId = null
                        this.$parent.$parent.businessName = ''
                      }
                      this.$message({
                        message: '材料添加成功',
                        type: 'success'
                      })
                    }
                  }
                } else {
                  if (this.$parent.$parent.businessId === item.businessId) {
                    this.$parent.$parent.$refs.erpTable.insertAt(item, -1)
                    this.$parent.$parent.getAddData()
                    this.$message({
                      message: '材料添加成功',
                      type: 'success'
                    })
                  } else {
                    this.$message({
                      message: `您选择的材料不是同一供应商`,
                      type: 'warning'
                    })
                  }
                }
              } else {
                this.$message({
                  message: '库存不足',
                  type: 'warning'
                })
              }
            }
          } else {
            if (this.receiptStatus === 0) { // 0新增 1详情
              if (this.$parent.$parent.businessId) {
                if (this.$parent.$parent.businessId === item.businessId) {
                  this.$parent.$parent.tableData.push(item)
                  if (item.businessId !== null) {
                    this.$parent.$parent.businessId = item.businessId
                    this.$parent.$parent.businessName = item.businessName
                  }
                  this.$message({
                    message: '材料添加成功',
                    type: 'success'
                  })
                } else {
                  this.$message({
                    message: `您选择的材料不是同一供应商`,
                    type: 'warning'
                  })
                }
              } else {
                if (this.$parent.$parent.tableData.length > 0) {
                  if (this.$parent.$parent.tableData[0].businessId === item.businessId) {
                    this.$parent.$parent.tableData.push(item)
                    if (item.businessId !== null) {
                      this.$parent.$parent.businessId = item.businessId
                      this.$parent.$parent.businessName = item.businessName
                    }
                    this.$message({
                      message: '材料添加成功',
                      type: 'success'
                    })
                  } else {
                    this.$message({
                      message: `您选择的材料不是同一供应商`,
                      type: 'warning'
                    })
                  }
                } else {
                  this.$parent.$parent.tableData.push(item)
                  if (item.businessId !== null) {
                    this.$parent.$parent.businessId = item.businessId
                    this.$parent.$parent.businessName = item.businessName
                  } else {
                    this.$parent.$parent.businessId = null
                    this.$parent.$parent.businessName = ''
                  }
                  this.$message({
                    message: '材料添加成功',
                    type: 'success'
                  })
                }
              }
            } else {
              if (this.$parent.$parent.businessId === item.businessId) {
                this.$parent.$parent.$refs.erpTable.insertAt(item, -1)
                this.$parent.$parent.getAddData()
                this.$message({
                  message: '材料添加成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  message: `您选择的材料不是同一供应商`,
                  type: 'warning'
                })
              }
            }
          }
        } else {
          this.$message({
            message: '材料已存在',
            type: 'warning'
          })
        }
      }
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getData()
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    height: 520px;
  }
  .addMaterialy /deep/ .el-dialog{
    height: 80%;
    display: flex;
    flex-direction: column;
  }
  .addMaterialy /deep/ .el-dialog__body{
    flex: 1;
    min-height: 0;
    height: 0;
  }
  .button{
    border: solid 1px #e2e2e2;
    border-radius: 4px;
    cursor: pointer;
  }
  .menu{
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
  }
  .hide-x{
    box-shadow: none!important;
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    font-weight: bold;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 10px;
    border-radius: 4px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/AddMaterialy.vue